import { useState } from "react";

export default function LanguageTabs({ languages, langData, setLangData }: { languages: any, langData: any, setLangData: (prev: any) => void }) {
    const [activeLang, setActiveLang] = useState(languages[0]?.label);
    

    const handleDescription = (label: string, value: any) => {
        setLangData((prev: any) => ({
            ...prev,
            [label]: {
                ...prev[label],
                description: value
            }
        }));
    };

    const current = languages.find((l: any) => l.label === activeLang);

    return (
        <div className="grid gap-6">

            {/* ---------- TABS ---------- */}
            <div className="flex gap-2 border-b border-slate-200 pb-2">
                {languages.map((lang: any) =>
                    lang.label && (
                        <button
                            key={lang.code}
                            className={`px-3 py-1 text-xs font-semibold rounded-lg transition
                                ${activeLang === lang.label
                                    ? "bg-emerald-500 text-white"
                                    : "bg-slate-100 text-slate-600 hover:bg-slate-200"
                                }`}
                            onClick={() => setActiveLang(lang.label)}
                        >
                            {lang.flag} {lang.label}
                        </button>
                    )
                )}
            </div>

            {/* ---------- LANGUAGE SETTINGS PANEL ---------- */}
            <div className="rounded-xl border border-slate-200 bg-slate-50 p-4">

                {/* Header row */}
                <div className="flex items-center justify-between mb-3">
                    <span className="flex items-center gap-2 text-sm font-medium text-slate-800">
                        <span className="text-lg">{current?.flag}</span>
                        {current?.label}
                    </span>
                </div>

                {/* Description Field */}
                <div className="grid gap-2">
                    <div className="flex items-center justify-between">
                        <label className="text-xs font-semibold text-slate-700">
                            Profile description ({current?.label})
                        </label>
                        <span className="text-[11px] text-slate-400">Visible to customers</span>
                    </div>

                    <div className="rounded-xl border border-slate-200 bg-white">
                        <div className="flex items-center gap-2 border-b border-slate-100 px-3 py-2 text-[11px] text-slate-500">
                            <span className="font-medium text-slate-600">Formatting</span>
                            <span className="mx-1 h-3 w-px bg-slate-200" />
                            <button className="font-semibold">B</button>
                            <button className="italic">I</button>
                            <button>• List</button>
                            <button>1. List</button>
                        </div>

                        <textarea
                            className="w-full rounded-b-xl bg-white px-3 py-2 text-xs outline-none"
                            rows={5}
                            placeholder={`Enter description for ${current?.label}…`}
                            value={langData[activeLang]?.description}
                            onChange={(e) =>
                                handleDescription(activeLang, e.target.value)
                            }
                            maxLength={100}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
}
